const formatAnalyticSummary = analyticsData => {
  const appLabels = [];
  const appData = {};
  const featureLabels = [];
  const featureData = {};
  analyticsData.data.reduce((acc, item) => {
    if (
      item.type === 'app' ||
      item.type === 'watch' ||
      item.type === 'listen'
    ) {
      if (appLabels.indexOf(item.description) < 0) {
        appLabels.push(item.description);
        appData[item.description] = {
          clicks: 1,
          dur: item.duration,
        };
      } else if (appLabels.indexOf(item.description) > -1) {
        appData[item.description].clicks = appData[item.description].clicks + 1;
        appData[item.description].dur =
          appData[item.description].dur + item.duration;
      }
    } else if (
      item.type === 'feature' &&
      !item.description.includes('navigate') &&
      !item.description.includes('click') &&
      !item.description.includes('select') &&
      !item.description.includes('connect')
    ) {
      if (featureLabels.indexOf(item.description) < 0) {
        featureLabels.push(item.description);
        featureData[item.description] = {
          clicks: 1,
          dur: item.duration,
        };
      } else if (featureLabels.indexOf(item.description) > -1) {
        featureData[item.description].clicks =
          featureData[item.description].clicks + 1;
        featureData[item.description].dur =
          featureData[item.description].dur + item.duration;
      }
    }
  });
  appLabels.map((label, index) => {
    appLabels[index] = { label, clicks: appData[label].clicks };
  });
  featureLabels.map((label, index) => {
    featureLabels[index] = { label, clicks: featureData[label].clicks };
  });
  appLabels.sort((a, b) => (a.clicks < b.clicks ? 1 : -1));
  featureLabels.sort((a, b) => (a.clicks < b.clicks ? 1 : -1));
  return {
    appLabels,
    appData,
    featureLabels,
    featureData,
  };
};

module.exports.formatAnalyticSummary = formatAnalyticSummary;
